import { getAxiosFulfilledState, getPendingState, resetState } from '../helpers/reducerHelper'
import { IReduxAction } from './index'
import { DataPromise, getDataEmptyState } from '../context/AxiosContext'
import { FilePartyAction, MainDto } from '../config/filePartyConfig'
import { ListItemDto, PartyAction } from '../config/partyConfig'
import { ActionType } from 'redux-promise-middleware'
import { FileAction } from '../config/fileConfig'
import { FileListItemDto } from '../context/FileContext'
import { FilePartyRoleDto } from '../context/GlobalContext'

export interface IFilePartyState {
    overview: DataPromise<MainDto[]>
    partyChildren: DataPromise<ListItemDto[]>
    roles: DataPromise<FilePartyRoleDto[]>
    suggestions: DataPromise<FileListItemDto[]>
}

const defaultState: IFilePartyState = {
    overview: getDataEmptyState<MainDto[]>(),
    partyChildren: getDataEmptyState<ListItemDto[]>(),
    roles: getDataEmptyState<FilePartyRoleDto[]>(),
    suggestions: getDataEmptyState<FileListItemDto[]>(),
}

export default function reducer(state: IFilePartyState = defaultState, action: IReduxAction): IFilePartyState {
    switch (action.type) {
        case `${FilePartyAction.GetOverview}_${ActionType.Pending}`: {
            return getPendingState(state, 'overview')
        }
        case `${FilePartyAction.GetOverview}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'overview')
        }
        case `${FilePartyAction.GetChildList}_${ActionType.Pending}`: {
            return getPendingState(state, 'partyChildren')
        }
        case `${FilePartyAction.GetChildList}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'partyChildren')
        }
        case `${FilePartyAction.GetSuggestions}_${ActionType.Pending}`: {
            return getPendingState(state, 'suggestions')
        }
        case `${FilePartyAction.GetSuggestions}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'suggestions')
        }
        case `${FilePartyAction.GetRoles}_${ActionType.Pending}`: {
            return getPendingState(state, 'roles')
        }
        case `${FilePartyAction.GetRoles}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'roles')
        }
        case FileAction.ResetCurrent:
        case FilePartyAction.ResetOverview:
        case PartyAction.Reset: {
            return resetState(state, { overview: null })
        }
    }
    return state
}
